import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationUserActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/User/UserBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationUser"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationUser"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationUserActivity)
